import styled from 'styled-components';
import { IFilterShortcutConstant } from '../../../../constants/filter/shortCut/filterShortcut.constant';
import { FilterShortcutButton } from './FilterShortcutButton';

interface IFilterShortcutButtonSectionProps {
  filterShortcutConstant: IFilterShortcutConstant;
}

export const FilterShortcutButtonSection = ({ filterShortcutConstant }: IFilterShortcutButtonSectionProps) => {
  return (
    <Container>
      <FilterShortcutButtonContainer>
        {filterShortcutConstant &&
          filterShortcutConstant.shortcutButtonInfos.length > 0 &&
          filterShortcutConstant.shortcutButtonInfos.map((shortcutInfo) => (
            <FilterShortcutButton
              key={shortcutInfo.logoUrl + shortcutInfo.title}
              filterType={filterShortcutConstant.filterType}
              logoUrl={shortcutInfo.logoUrl}
              navigateTo={shortcutInfo.navigateTo}
              title={shortcutInfo.title}
            />
          ))}
      </FilterShortcutButtonContainer>
    </Container>
  );
};

const Container = styled.div`
  overflow-x: scroll;
  padding: 8px 16px 16px 16px;

  display: flex;
  align-items: center;
  align-self: stretch;
`;

const FilterShortcutButtonContainer = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  gap: 16px;
`;
